import React, { useState } from 'react'
import moment from 'moment'
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import DialogTitle from '@material-ui/core/DialogTitle';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import ArrowLeft from '@material-ui/icons/ArrowLeft';
import ArrowRight from '@material-ui/icons/ArrowRight';
import { useEffect } from 'react';
import { CircularProgress, FormHelperText, Grid, Input, TextField } from '@material-ui/core';
import { fetchShifts, fetchUsers, fetchEvents, postEvents, deleteEvents } from '../business/api'
const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  grow: {
    flexGrow: 1,
  },
  offset: theme.mixins.toolbar,
}));

const API = process.env.REACT_APP_API_END_POINT;
const VacationSheet = props => {
  const [events, setEvent] = React.useState({})
  const [maxColumn, setMaxColumn] = useState(0)
  const [eventYear, setYear] = React.useState(moment().year())
  const [eventMonth, setMonth] = React.useState(moment().month())
  const classes = useStyles();
  useEffect(() => {
    loadEvents();
  }, [eventMonth, eventYear])
  const prevMonth = () => {
    let date = moment(`${eventYear}-${eventMonth + 1}`, 'YYYY-MM').subtract(1, 'months');
    updateDate(date)
  }
  const nextMonth = () => {
    let date = moment(`${eventYear}-${eventMonth + 1}`, 'YYYY-MM').add(1, 'months');
    updateDate(date)
  }
  const updateDate = (date) => {
    if (date.month() !== eventMonth) setMonth(date.month());
    if (date.year() !== eventYear) setYear(date.year());
  }
  const onRequestOff = ({ date, shift_id, covering, coveringPerson, user_id }) => {
    if (window.confirm(`Confirm Request?`)) {
      postEvents({ date: moment(date).format('YYYY-MM-DD'), shift_id, covering, coveringPerson, user_id })
        .then(json => alert(json.message))
        .then(loadEvents)
        .catch(error => console.log(error))
    }
  }
  const onRequestRemove = (id, date) => {
    if (window.confirm(`Withdraw request?`)) {
      deleteEvents({ id, date: moment(date).format('YYYY-MM-DD') })
        .then(json => alert(json.message))
        .then(loadEvents)
        .catch(error => console.log(error))
    }
  }
  const loadEvents = (response) => {
    fetchEvents(eventMonth + 1, eventYear).then(parseEvents)
  }
  const parseEvents = json => {
    let totalDaysInMonth = moment(`${eventYear}-${eventMonth + 1}`, 'YYYY-MM').daysInMonth();
    let data = {};
    for (var i = 0; i < totalDaysInMonth; i++) {
      data[moment(`${eventYear}-${eventMonth + 1}-${i + 1}`, 'YYYY-MM-DD').format('YYYY-MM-DD')] = [];
    }
    json.map(entry => data[entry.date].push({ ...entry, after6: data[entry.date].length > 5 }));
    let maxC = 0;

    Object.keys(data).map((event, index) => { maxC = Math.max(maxC, data[event].length) });
    setMaxColumn(maxC);
    setEvent(data)
  }
  return (
    <div>
      <div className={classes.root}>
        <AppBar position="fixed">
          <Toolbar>
            <Typography variant="h6" className={classes.title}>Vacation Planner</Typography>
            <div className={classes.grow} />
            <Button startIcon={<ArrowLeft />} style={{ marginRight: 8 }} variant="outlined" color="inherit" onClick={prevMonth}>Previous Month</Button>
            <Button endIcon={<ArrowRight />} variant="outlined" color="inherit" onClick={nextMonth}>Next Month</Button>
            <Button onClick={props.onLogout} color="inherit">Logout</Button>
          </Toolbar>
        </AppBar>
      </div>
      <div className={classes.offset} />
      <div className={'sheet-wrapper'}>
        <table>
          <tbody>
            {Object.keys(events).map((event, index) => <SheetRow key={index} maxColumn={maxColumn} alternateRow onRequestOff={onRequestOff} onRequestRemove={onRequestRemove} key={event} date={event} columns={events[event]} />)}
          </tbody>
        </table>
      </div>
    </div>
  )
}
const SheetRow = ({ date, columns, onRequestRemove, onRequestOff, maxColumn }) => {
  const [open, setOpen] = useState(false);
  /**
   * SHIFT STATE
   */
  const [shift_id, setShift] = useState(null);
  const [shifts, setShifts] = useState([]);
  /**
   * USER STATE
   */
  const [user_id, setUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [busy, setBusy] = useState(false);
  const [covering, setCovering] = useState(false);
  const [coveringPerson, setCoveringPerson] = useState("");
  const mdate = moment(date, 'YYYY-MM-DD');
  const classes = useStyles();
  /**
   * 
   * @param {*} event 
   * @returns 
   * call back from user selection dropdown
   */
  const handleChangeUser = event => setUser(event.target.value)
  /**
   * 
   * @param {*} event 
   * @returns 
   * callback from shift selection dropdown
   */
  const handleChangeShift = event => setShift(event.target.value);
  /**
   * Open dialog for request. This first will fetch shifts and then users.
   * Users will be loaded only if admin.
   */
  const handleClickOpen = () => {
    setOpen(true);
    if (shifts.length === 0 && !busy) {
      setBusy(true)
      fetchShifts().then(setShifts).then(fetchUsers).then(setUsers).then(result => setBusy(false))
    }
  };
  /**
   * Close request dialog
   */
  const handleClose = () => {
    setShift("")
    setCovering(false);
    setOpen(false);
  }

  const cellRequestRemove = (id) => onRequestRemove(id, date);
  const requestDayOff = () => {
    if (covering && coveringPerson.trim() === "") {
      return alert("Please provide a covering person.")
    }
    handleClose();
    onRequestOff({ date, shift_id, covering, coveringPerson, user_id })
  }
  const onCheckedCovering = event => { setCoveringPerson(""); setCovering(event.target.checked); }
  const onChangeCoveringPerson = event => setCoveringPerson(event.target.value);
  let totalColumns = columns.length > 6 ? maxColumn : maxColumn + 1;
  let extraColumns = totalColumns > columns.length ? new Array(totalColumns - columns.length).fill('') : null;
  return (
    <tr className={`sheet-row ${(mdate.day() === 0 || mdate.day() === 6) ? 'weekend' : ""}`}>
      <td style={{ width: 100, padding: 4 }}>{mdate.format('MM-DD-YYYY')}</td>
      {columns.map((column, index) => {
        return <>
          {index === 6 ? <td key={'extra'} className={'blank'} dangerouslySetInnerHTML={{ __html: '&nbsp;' }}></td> : null}
          <SheetCell key={index} onRequestRemove={cellRequestRemove} {...column} />
        </>
      })}
      {
        extraColumns ? extraColumns.map((row, index) => <td key={index} dangerouslySetInnerHTML={{ __html: '&nbsp;' }}></td>) : null
      }
      <td className={'grow'} dangerouslySetInnerHTML={{ __html: '&nbsp;' }}></td>
      <td style={{ width: 160 }}><Button startIcon={<AddIcon />} style={{ fontSize: 11, paddingTop: 1, paddingBottom: 1, paddingLeft: 4, paddingRight: 4 }} variant={'contained'} onClick={handleClickOpen}>MAKE A REQUEST</Button></td>
      <Dialog maxWidth={'sm'} fullWidth open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        {
          busy ?
            <CircularProgress />
            :
            <>
              <DialogTitle id="form-dialog-title">{`Make a Request for ${moment(date).format('DD MMM, YYYY')}.`}</DialogTitle>
              <DialogContent>
                <Grid container>
                  <Grid item xs={12}>
                    {users.length ?
                      <FormControl className={classes.formControl} fullWidth>
                        <Select
                          id="demo-simple-select-outlined"
                          value={user_id}
                          onChange={handleChangeUser}
                          label="User"
                          fullWidth
                          placeholder="Select a user"
                          inputProps={{ 'aria-label': 'Without label' }}
                        >
                          {users.map(entry => <MenuItem key={entry.short_name} value={entry.user_id}>{entry.short_name}</MenuItem>)}
                        </Select>
                        <FormHelperText>Select a User</FormHelperText>
                      </FormControl>
                      :
                      null
                    }
                    <FormControl className={classes.formControl} fullWidth>
                      <Select
                        id="demo-simple-select-outlined"
                        value={shift_id}
                        onChange={handleChangeShift}
                        label="Shift"
                        fullWidth
                        placeholder="Select a shift"
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        {shifts.map(entry => <MenuItem key={entry.label} value={entry.shift_id}>{entry.label}</MenuItem>)}
                      </Select>
                      <FormHelperText>Select a Shift</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={6}>
                      <FormControlLabel
                        control={<Checkbox checked={covering} onChange={onCheckedCovering} name="checkedA" />}
                        label="Covering"
                      />
                    </Grid>
                    {covering ? <Grid item xs={6}> <Input onChange={onChangeCoveringPerson} placeholder={'Who?'} inputProps={{ 'aria-label': 'description' }} /></Grid> : null}
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={requestDayOff} color="primary">
                  Send Request
                </Button>
              </DialogActions>
            </>
        }
      </Dialog>
    </tr>
  )
}
const SheetCell = ({
  date,
  removable,
  is_active,
  after6,
  onRequestRemove,
  shift_label,
  label,
  id
}) => {
  const onClick = () => {
    if (removable) { onRequestRemove(id); }
  }
  let cellStyle = [];
  if (removable) cellStyle.push('pointer');
  if (after6) cellStyle.push('after6');
  if (!is_active) cellStyle.push('line-through');
  return (
    <td onClick={onClick} className={cellStyle.join(" ")} style={{
      width: shift_label ? 110 : null,
    }}>{label}</td>)
}
export default VacationSheet;